import React from 'react';
import {
  FaChartLine,
  FaBuilding,
  FaProjectDiagram,
  FaGlobeAsia,
  FaCheckCircle,
  FaLightbulb,
  FaTools,
  FaLeaf,
} from 'react-icons/fa';
import './Vision.css';

const visionItems = [
  {
    title: 'EMERGING',
    description: 'Emerging as a Market Leader in Metal Coating Technology by 2025',
    icon: <FaChartLine />,
  },
  {
    title: 'BUILDING',
    description: 'Building Trust, Responsibility and Reliability of Brand, "CED Coatings"',
    icon: <FaBuilding />,
  },
  {
    title: 'INTEGRATION',
    description: "Integrating backward and forward with OEM's for various parts and services",
    icon: <FaProjectDiagram />,
  },
  {
    title: 'EXPANDING MARKETS',
    description: 'Targeting Asian and Middle Eastern countries markets for Exports',
    icon: <FaGlobeAsia />,
  },
  {
    title: 'RELIABLE QUALITY',
    description: "Respond to our customers' needs with reliable deliveries that do not compromise quality",
    icon: <FaCheckCircle />,
  },
  {
    title: 'INNOVATE & ADVANCE',
    description: 'Continuously improve by embracing innovation and change to advance as a company',
    icon: <FaLightbulb />,
  },
  {
    title: 'EXPERT SURFACE ENGINEERING',
    description: 'Provide expertise in surface engineering and best-value in metal finishing solutions through the integration of people, business systems and technology',
    icon: <FaTools />,
  },
  {
    title: 'ENVIRONMENTAL STEWARDSHIP',
    description: 'To be a Steward of our environment embracing pollution prevention methodologies that meet or exceeds all local, state and federal regulations',
    icon: <FaLeaf />,
  },
];

const CEDCoatings = () => {
  return (
    <div className="ced-coatings-container">
      <h1 className="ced-coatings-title">
        CED COATINGS VISION & MISSION
        <div className="underline"></div>
      </h1>
      <div className="ced-coatings-grid fixed-grid">
        {visionItems.map((item, index) => (
          <div key={index} className="plain-item">
            <span className="plain-icon">{item.icon}</span>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CEDCoatings;
